module.exports = __webpack_public_path__ + "img/core-temp-icon.8f9bd5ed.svg";